import { useTranslation } from 'react-i18next';

import RedButton from 'components/buttons/RedButton';
import { ItemDto } from 'services/item/itemService.dto';

import { useListOfSoldPopup } from './useListOfSoldPopup';

interface Props {
  item: ItemDto;
  onContactUser: (userId?: number) => void;
}

export const ListOfSoldButton = ({ item, onContactUser }: Props) => {
  const { t } = useTranslation('myProfile');
  const { showListOfSoldPopup } = useListOfSoldPopup();

  return (
    <RedButton data-testid={'list-of-sold-btn'} onClick={() => showListOfSoldPopup({ item, onContactUser })}>
      {t('tracked-item.multiple-list')}
    </RedButton>
  );
};
